import API_TYPE from '../plugins/qianniu-pc-api-type';

let {QN_APP, TOP} = API_TYPE;

export default (context, next) => {
  let {api} = context;
  if (!api.routes) {
    switch (api.type) {
      case QN_APP:
        api.routes = ['application'];
        break;
      case TOP:
        api.routes = ['top'];
        break;
      default:
        // transform `QN.jdy` to `jdy`
        api.routes = [api.type.replace(/^QN\./, '')];
    }
  }
  next();
};



// WEBPACK FOOTER //
// ./src/middlewares/qianniu-pc-routes-complete.js